// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getSettingsCollection } from "@conklin/App/Store/Selectors/SettingsSelectors";
import { getHasCompletedCustomerSelection } from "@conklin/App/Utilities/changeCustomerSelectionStorage";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import Zone from "@insite/client-framework/Components/Zone";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { shallowEqual } from "react-redux";

// XNG-Changes
const ChangeCustomerPage = ({ id, history }: PageProps & HasHistory) => {
    // <XNG-Changes>
    const { lockCustomerSelection, dashboardUrl } = useAppSelector(state => {
        return {
            lockCustomerSelection: getSettingsCollection(state).customSettings?.lockCustomerSelection,
            dashboardUrl: getPageLinkByPageType(state, "MyAccountPage")?.url,
        };
    }, shallowEqual);

    const hasCompletedSelection = getHasCompletedCustomerSelection();

    React.useEffect(() => {
        if (!lockCustomerSelection) {
            return;
        }

        if (dashboardUrl && hasCompletedSelection) {
            history.push(dashboardUrl);
        }
    }, [dashboardUrl, hasCompletedSelection, lockCustomerSelection]);

    if (lockCustomerSelection && hasCompletedSelection) {
        return null;
    }
    // </XNG-Changes>

    return (
        <Page>
            <Zone contentId={id} zoneName="Content" />
        </Page>
    );
};

const pageModule: PageModule = {
    // XNG-Changes
    component: withHistory(ChangeCustomerPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "ChangeCustomerPage" instead of this constant.
 */
export const ChangeCustomerPageContext = "ChangeCustomerPage";
